<script lang="ts">
  import { transformListKey } from '$shared/helpers/ListKeyFormat';

  let { value = {} } = $props();
</script>

<div class="npdp-report-summary-list-type">
  {#each Object.entries(value) as [key, value]}
    <div class="list-i">
      <div class="key" data-cy={`${key}-k`}>{transformListKey(key)}</div>
      {#if value}
        <div class="value highlight" data-cy={`${key}-v`}>Yes, See Attached Report</div>
      {:else}
        <div class="value" data-cy={`${key}-v`}>No Reports</div>
      {/if}
    </div>
  {:else}
    <div class="empty" data-cy="empty-report">No Report Found</div>
  {/each}
</div>

<style>
  .npdp-report-summary-list-type {
    width: 100%;
  }
  .list-i {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  .list-i:not(:first-child) {
    padding-top: 8px;
  }
  .value.highlight {
    background-color: var(--yellow);
    padding: 4px 8px;
    border-radius: 3px;
  }
</style>
